import {
  FormPayload,
  PreprocessorConfiguration,
  PreprocessorTypes,
} from '@cashier/cashier-model';

import { TokenizerV1Service } from './tokenizerV1';

export const PreProcessorPayloadFilter = {
  filter: (
    payload: FormPayload,
    preprocessor: PreprocessorConfiguration | null,
  ): FormPayload => {
    if (!preprocessor) {
      return payload;
    }

    switch (preprocessor.type) {
      case PreprocessorTypes.TOKENIZER_V1:
        return TokenizerV1Service.filterPayload(payload);

      default:
        return payload;
    }
  },
};
